import { Component } from '@angular/core';

import { BadgeComponent } from '@camelot/ui';
import { MissionType } from '@camelot/user';
import { extractEnum } from '@camelot/utils';

import { AbstractCellComponent } from '../../abstract';

@Component({
  host: { 'data-cid': 'grid-mission-type-cell' },
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '',
  imports: [BadgeComponent],
  template: `
    <div class="simple-flex align-center g-space-xs" style="height: 100%">
      @for (missionType of this.value; track missionType) {
        <cam-badge [value]="'user.mission-type.' + this.missionTypeLabel(missionType)" class="d-flex"></cam-badge>
      }
    </div>
  `,
})
export class GridMissionTypeCellComponent extends AbstractCellComponent<any, MissionType[]> {
  public missionTypeLabel(missionType: MissionType) {
    return extractEnum(MissionType, true).find(x => x.value === missionType)?.name;
  }
}
